/* eslint-disable @typescript-eslint/naming-convention */
import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const PartnerService = httpFactory({ baseURL: configurationURL.dashboard.baseUrl + '/api' });

const extractPartnerList = response => response?.data?.partners || [];

const mimicBackendSearch = (response, search) => {
  if (search) {
    const lowercaseSearch = String(search).toLowerCase();
    return response.filter(partner => {
      const lowerCaseDisplayName = String(partner.partner_display_name).toLowerCase();
      const lowerCaseName = String(partner.name).toLowerCase();

      return lowerCaseDisplayName.includes(lowercaseSearch) || lowerCaseName.includes(lowercaseSearch);
    });
  }

  return response;
};

export const getPartnerList = ({ search, ...params }) =>
  PartnerService.get(`/skad_partners`, {
    params: {
      ...params,
    },
  })
    .then(extractPartnerList)
    .then(response => mimicBackendSearch(response, search));

export const getPartnerListWithAccessDetails = ({ access, search, ...params }) =>
  getPartnerList({ search, ...params }).then(response => {
    if (!access?.partners) {
      return response;
    }

    return response.map(partner => {
      const accessDetail = access.partners.find(accessDetail => String(accessDetail.partner_id) === String(partner.id));

      if (accessDetail) {
        partner.access = {
          token: accessDetail.partner_id,
          role: accessDetail.role,
        };
      }

      return partner;
    });
  });
